<template>
  <div class="devices-tab">
    <div class="empty-state">
      <i class="mdi mdi-devices"></i>
      <p>Пристрої будуть реалізовані найближчим часом</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DevicesTab',
  props: {
    ticket: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.devices-tab {
  padding: 24px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #adb5bd;
  text-align: center;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}
</style>
